import React from 'react';
import { IPage } from 'layouts/Navbar/Navbar.types';
import NavbarLink from 'layouts/Navbar/NavbarLink';

import { Box, IconButton, Menu, MenuItem } from '@mui/material';

interface NavbarMobileLinksProps {
  pages: IPage[];
  anchorEl: null | HTMLElement;
  onIconClick: (event: React.MouseEvent<HTMLElement>) => void;
  onNavClose: () => void;
}

const NavbarMobileLinks: React.FunctionComponent<NavbarMobileLinksProps> = ({
  pages,
  anchorEl,
  onIconClick,
  onNavClose,
}) => {
  return (
    <Box sx={styles.container}>
      <IconButton
        aria-label='account of current user'
        aria-controls='menu-appbar'
        aria-haspopup='true'
        onClick={onIconClick}
        color='inherit'
      >
        <i className='fas fa-bars'></i>
      </IconButton>
      <Menu
        id='menu-appbar'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={Boolean(anchorEl)}
        onClose={onNavClose}
        sx={styles.menu}
      >
        {pages.map((page) => (
          <MenuItem key={page.path} onClick={onNavClose}>
            <NavbarLink key={page.path} page={page} color='757ce8' />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

const styles = {
  container: {
    flexGrow: 1,
    flexDirection: 'row-reverse',
    display: { xs: 'flex', md: 'none' },
  },
  menu: {
    display: { xs: 'block', md: 'none' },
    width: '100%',
  },
};

export default NavbarMobileLinks;
